import React, { useEffect, useState, useRef } from "react";
import { X, ChevronDown, ChevronRight, ListPlus } from "lucide-react";
import axios from "../../routers/axios";
import AddQuestionComponent from "../add_question";
import QuestionBankModal from "./QuestionBankModal";
import AddReadingWritingModal from "./AddReadingWritingModal";
import AddExercisesModal from "./AddExercisesModal";
import CreateReadingWritingModal from "./CreateReadingWritingModal";



// 🔹 Import setup TinyMCE LOCAL
// import "../common/tinymce-setup";  

import { Editor } from "@tinymce/tinymce-react";

const ScenarioDetailModal = ({ scenario, onClose }) => {
  const [activeTab, setActiveTab] = useState("edit");
  const [subTab, setSubTab] = useState("reading");
  const [questions, setQuestions] = useState([]);
  const [activeQuestionTab, setActiveQuestionTab] = useState("reading");
  const [showAddQuestion, setShowAddQuestion] = useState(false);
  const [showQuestionBank, setShowQuestionBank] = useState(false);
  const [formReading, setFormReading] = useState({});
  const [formWriting, setFormWriting] = useState({});
  const [openSections, setOpenSections] = useState({});
  const [hasReading, setHasReading] = useState(false);
  const [hasWriting, setHasWriting] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showCreateReadingModal, setShowCreateReadingModal] = useState(false);
  const [showCreateWritingModal, setShowCreateWritingModal] = useState(false);
  const [showAddExercisesModal, setShowAddExercisesModal] = useState(false);





  const editorRefs = useRef({});

  const editorConfig = {
    height: 300,
    menubar: true,
    plugins: [
      'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
      'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
      'insertdatetime', 'media', 'table', 'help', 'wordcount'
    ],
    toolbar:
      'undo redo | blocks | ' +
      'bold italic underline forecolor | alignleft aligncenter alignright alignjustify | ' +
      'bullist numlist outdent indent | link image media table | code fullscreen | help',
    content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
    paste_data_images: true,
    paste_word_valid_elements:
      'b,strong,i,em,h1,h2,h3,h4,h5,h6,ul,ol,li,p,br,table,tr,td,th',
  };


  useEffect(() => {
    if (scenario?.id) {
      fetchReading();
      fetchWriting();
      reloadQuestions();
    }
  }, [scenario?.id]);

  const fetchReading = async () => {
    try {
      const res = await axios.get(`/scenarios/reading/${scenario.id}`);
      if (res.data && Object.keys(res.data).length > 0) {
        setFormReading(res.data);
        setHasReading(true);
      } else {
        setHasReading(false);
      }
    } catch (err) {
      console.warn("No reading found for scenario", scenario.id);
      setHasReading(false);
    }
  };

  const fetchWriting = async () => {
    try {
      const res = await axios.get(`/scenarios/writing/${scenario.id}`);
      if (res.data && Object.keys(res.data).length > 0) {
        setFormWriting(res.data);
        setHasWriting(true);
      } else {
        setHasWriting(false);
      }
    } catch (err) {
      console.warn("No writing found for scenario", scenario.id);
      setHasWriting(false);
    }
  };


  const reloadQuestions = async () => {
    const res = await axios.get(`/questions/list?scenario_id=${scenario.id}`);
    setQuestions(res.data || []);
  };

  const toggleSection = (key) =>
    setOpenSections((prev) => ({ ...prev, [key]: !prev[key] }));

  const handleEditorChange = (field) => (content) => {
    editorRefs.current[field] = content;
  };

  const handleUpdateReading = async () => {
    try {
      const payload = { ...formReading };
      Object.keys(editorRefs.current).forEach((k) => {
        if (k.startsWith("reading_") || k.startsWith("passage_") || k.startsWith("marking_"))
          payload[k] = editorRefs.current[k];
      });
      await axios.put(`/scenarios/reading/update/${scenario.id}`, payload);
      alert("Đã cập nhật phần Reading!");
      fetchReading();
    } catch (err) {
      console.error(err);
      alert("Lỗi khi cập nhật Reading!");
    }
  };

  const handleUpdateWriting = async () => {
    try {
      const payload = { ...formWriting };
      Object.keys(editorRefs.current).forEach((k) => {
        if (!k.startsWith("reading_") && !k.startsWith("passage_"))
          payload[k] = editorRefs.current[k];
      });
      await axios.put(`/scenarios/writing/update/${scenario.id}`, payload);
      alert("Đã cập nhật phần Writing!");
      fetchWriting();
    } catch (err) {
      console.error(err);
      alert("Lỗi khi cập nhật Writing!");
    }
  };

  if (!scenario) return null;

  const renderEditor = (label, field) => (
    <Accordion title={label} fieldKey={field} openSections={openSections} toggleSection={toggleSection}>
      <Editor
        apiKey="a7bzgpdrc4fmam222696wcyaaybnyn3vmqk9wk86wamc80as"
        // apiKey="a7bzgpdrc4fmam222696wcyaaybnyn3vmqk9wk86wamc80as"
        initialValue={formReading[field] || formWriting[field] || ""}
        init={editorConfig}
        onEditorChange={handleEditorChange(field)}
      />
    </Accordion>
  );

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl w-full max-w-6xl shadow-xl overflow-hidden max-h-[90vh] flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b">
          <h2
            className="text-xl font-bold"
            dangerouslySetInnerHTML={{
              __html: scenario.scenario_name
                ?.replace(/&lt;/g, "<")
                ?.replace(/&gt;/g, ">")
                ?.replace(/&amp;/g, "&"),
            }}
          ></h2>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg">
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Tabs */}
        <div className="flex border-b">
          {["edit", "questions"].map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`px-4 py-2 font-medium ${activeTab === tab
                ? "border-b-2 border-blue-600 text-blue-600"
                : "text-gray-500"
                }`}
            >
              {tab === "edit" ? "Sửa" : "Câu hỏi"}
            </button>
          ))}
        </div>

        <div className="p-6 overflow-y-auto flex-1">
          {/* === TAB SỬA === */}
          {activeTab === "edit" && (
            <>
              <div className="flex items-center justify-between mb-4">
                <div className="flex gap-3">
                  {["reading", "writing"].map((t) => (
                    <button
                      key={t}
                      onClick={() => setSubTab(t)}
                      className={`px-4 py-2 rounded-lg ${subTab === t ? "bg-blue-600 text-white" : "bg-gray-100 text-gray-700"
                        }`}
                    >
                      {t === "reading" ? "Reading" : "Writing"}
                    </button>
                  ))}
                </div>

                <div className="flex items-center gap-3">
                  {/* ➕ Nút Add Exercises - chỉ hiển thị khi đang ở Writing */}
                  {subTab === "writing" && (
                    <button
                      onClick={() => setShowAddExercisesModal(true)}
                      className="flex items-center gap-2 text-green-600 hover:text-green-800 font-medium"
                      title="Thêm bài luyện tập Writing (CV Form)"
                    >
                      <ListPlus className="w-5 h-5" />
                      <span>Add Exercises</span>
                    </button>
                  )}

                  {/* 📚 Nút Reading & Writing Bank */}
                  <button
                    onClick={() => setShowAddModal(true)}
                    className="flex items-center gap-2 text-blue-600 hover:text-blue-800 font-medium"
                    title="Thêm Reading/Writing từ thư viện"
                  >
                    <ListPlus className="w-5 h-5" />
                    <span>Reading & Writing Bank</span>
                  </button>
                </div>
              </div>
              {/* READING */}
              {subTab === "reading" && (
                hasReading ? (
                  <div className="relative flex flex-col h-full">
                    <div className="flex-1 overflow-y-auto space-y-4 pb-24">
                      {[
                        "reading_title", "reading_description", "reading_duration",
                        "reading_video", "reading_instruction",
                        "passage_title", "passage_content",
                        "passage_reference", "passage_notes",
                        "marking_rubric", "video_filename"
                      ].map((f) => (
                        <React.Fragment key={f}>{renderEditor(f, f)}</React.Fragment>
                      ))}
                    </div>
                    <div className="absolute bottom-0 left-0 right-0 bg-white border-t flex justify-end p-4">
                      <button onClick={handleUpdateReading} className="bg-blue-600 text-white px-4 py-2 rounded-lg">
                        💾 Lưu thay đổi Reading
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="text-center text-gray-500 py-20">
                    🚫 Scenario này chưa có bài Reading nào.
                  </div>
                )
              )}


              {/* WRITING */}
              {subTab === "writing" && (
                hasWriting ? (
                  <div className="space-y-4">
                    {[
                      "writing_title", "writing_type", "level", "estimated_time_minutes",
                      "instruction_intro", "instruction_additional", "instruction_image", "instruction_video",
                      "message_title", "message_sender", "message_text", "message_image",
                      "guidelines_title", "guidelines_description",
                      "sample_response_available", "sample_response_note",
                      "rubric_description", "outline_enabled", "outline_instruction", "outline_placeholder",
                      "writing_instruction", "writing_placeholder",
                      "submission_note", "max_word_count",
                      "rubric_json", "rubric_id"
                    ].map((f) => (
                      <React.Fragment key={f}>{renderEditor(f, f)}</React.Fragment>
                    ))}
                    <div className="flex justify-end pt-4">
                      <button onClick={handleUpdateWriting} className="bg-blue-600 text-white px-4 py-2 rounded-lg">
                        💾 Lưu thay đổi Writing
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="text-center text-gray-500 py-20">
                    🚫 Scenario này chưa có bài Writing nào.
                  </div>
                )
              )}

            </>
          )}

          {/* === TAB CÂU HỎI === */}
          {activeTab === "questions" && (
            <div>
              <div className="flex gap-3 mb-3">
                {["reading", "writing"].map((t) => (
                  <button
                    key={t}
                    onClick={() => setActiveQuestionTab(t)}
                    className={`px-3 py-1 rounded-lg ${activeQuestionTab === t
                      ? "bg-blue-600 text-white"
                      : "bg-gray-100 text-gray-700"
                      }`}
                  >
                    {t === "reading" ? "Reading" : "Writing"}
                  </button>
                ))}
              </div>

              <div className="flex justify-between items-center mb-3">
                <h3 className="text-lg font-semibold">Danh sách câu hỏi</h3>
                <div className="flex gap-2">
                  <button
                    onClick={() => setShowQuestionBank(true)}
                    title="Chọn từ ngân hàng câu hỏi"
                    className="flex items-center gap-2 px-3 py-2 border rounded-lg hover:bg-gray-100 text-blue-600 font-medium transition"
                  >
                    <ListPlus className="w-5 h-5" />
                    <span>Question Bank</span>
                  </button>
                </div>
              </div>

              <div className="overflow-x-auto">
                <table className="w-full text-sm border">
                  <thead>
                    <tr className="bg-gray-50">
                      <th className="border px-2 py-1 text-left">ID</th>
                      <th className="border px-2 py-1 text-left">Type</th>
                      <th className="border px-2 py-1 text-left">Question</th>
                      <th className="border px-2 py-1 text-left">Ghi chú</th>
                    </tr>
                  </thead>
                  <tbody>
                    {questions
                      .filter((q) => !q.section || q.section === activeQuestionTab)
                      .map((q) => (
                        <tr key={q.id}>
                          <td className="border px-2 py-1">{q.id}</td>
                          <td className="border px-2 py-1 capitalize">{q.question_type}</td>
                          <td className="border px-2 py-1">{q.question_text}</td>
                          <td className="border px-2 py-1 text-gray-400 italic text-center">
                            (Sửa/xóa tại Ngân hàng câu hỏi)
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>

              {showQuestionBank && (
                <QuestionBankModal
                  section={activeQuestionTab}
                  scenarioId={scenario.id}
                  onClose={() => {
                    setShowQuestionBank(false);
                    reloadQuestions();
                  }}
                />
              )}

            </div>
          )}
        </div>
      </div>
      <AddReadingWritingModal
        isOpen={showAddModal}
        onClose={() => setShowAddModal(false)}
        scenarioId={scenario?.id}
        onAdded={() => {
          fetchReading();
          fetchWriting();
        }}
        onCreateNew={(type) => {
          if (type === "reading") {
            setShowCreateReadingModal(true);
          } else {
            setShowCreateWritingModal(true);
          }
        }}
      />
      <CreateReadingWritingModal
        isOpen={showCreateReadingModal}
        onClose={() => setShowCreateReadingModal(false)}
        type="reading"
        onCreated={() => {
          fetchReading();
          setShowCreateReadingModal(false);
        }}
      />

      <CreateReadingWritingModal
        isOpen={showCreateWritingModal}
        onClose={() => setShowCreateWritingModal(false)}
        type="writing"
        onCreated={() => {
          fetchWriting();
          setShowCreateWritingModal(false);
        }}
      />
      {showAddExercisesModal && (
        <AddExercisesModal
          isOpen={showAddExercisesModal}
          onClose={() => setShowAddExercisesModal(false)}
          scenarioId={scenario.id}
        />
      )}

    </div>
  );
};

// Accordion Component
const Accordion = ({ title, fieldKey, openSections, toggleSection, children }) => (
  <div className="border rounded-lg">
    <button
      onClick={() => toggleSection(fieldKey)}
      className="w-full flex justify-between items-center px-4 py-2 text-left font-semibold bg-gray-100 hover:bg-gray-200"
    >
      {title}
      {openSections[fieldKey] ? (
        <ChevronDown className="w-5 h-5" />
      ) : (
        <ChevronRight className="w-5 h-5" />
      )}
    </button>
    {openSections[fieldKey] && <div className="p-4 bg-white">{children}</div>}
  </div>
);

export default ScenarioDetailModal;
